/*
 * Profile
 */
export const SET_PROFILE = "SET_PROFILE";

/*
 * Master Data
 */
export const SET_MASTERDATA = "SET_MASTERDATA";
